export default __webpack_public_path__ + "static/media/poster-marcel.42db451f.jpg";